// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H8CxM","content":"styles_content__1QVC-","row":"styles_row__2_MRR","footer":"styles_footer__1qeSa","phraseLength":"styles_phraseLength__2t-Ca"};